export default __webpack_public_path__ + "static/firebase-a5f9f1fd96c36040dd434f71d5765c29.png";